import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  ClassFocusSession,
  ClassSessionInvitation
} from 'interfaces/class-session.interface';
import { initialClassSessionState } from 'store/initial-states';

const classSession = createSlice({
  name: 'classSession',
  initialState: initialClassSessionState,
  reducers: {
    updateAreInvitationsLoading: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.areInvitationsLoading = payload;
    },
    updateInvitations: (
      state,
      { payload }: PayloadAction<ClassSessionInvitation[]>
    ) => {
      state.invitations = payload;
    },
    updateIsCurrentSessionLoading: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.isCurrentSessionLoading = payload;
    },
    updateCurrentSession: (
      state,
      { payload }: PayloadAction<ClassFocusSession | null>
    ) => {
      state.currentSession = payload;
    },
    updateIsJoining: (state, { payload }: PayloadAction<boolean>) => {
      state.isJoining = payload;
    },
    updateIsLeaving: (state, { payload }: PayloadAction<boolean>) => {
      state.isLeaving = payload;
    },
    updateIsDeclining: (state, { payload }: PayloadAction<boolean>) => {
      state.isDeclining = payload;
    },
    updateIsSubmittingUnlock: (state, { payload }: PayloadAction<boolean>) => {
      state.isSubmittingUnlock = payload;
    },
    updateLastHeartbeatAt: (
      state,
      { payload }: PayloadAction<string | null>
    ) => {
      state.lastHeartbeatAt = payload;
    },
    clearClassSessionState: (state) => {
      state.invitations = [];
      state.currentSession = null;
      state.lastHeartbeatAt = null;
    }
  }
});

export const {
  updateAreInvitationsLoading,
  updateInvitations,
  updateIsCurrentSessionLoading,
  updateCurrentSession,
  updateIsJoining,
  updateIsLeaving,
  updateIsDeclining,
  updateIsSubmittingUnlock,
  updateLastHeartbeatAt,
  clearClassSessionState
} = classSession.actions;

export default classSession.reducer;
